import { render, staticRenderFns } from "./addNedit-people.vue?vue&type=template&id=4bee8e1e&scoped=true&"
import script from "./addNedit-people.vue?vue&type=script&lang=js&"
export * from "./addNedit-people.vue?vue&type=script&lang=js&"
import style0 from "./addNedit-people.vue?vue&type=style&index=0&id=4bee8e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee8e1e",
  null
  
)

export default component.exports